import React, {Component} from 'react'
import PropTypes from 'prop-types'
import wrappedIntlComponent from "./intl/WrappedIntlComponent"
import Header from './Header'
import Footer from "./Footer"
import blockerWrapper from "./blocker/BlockerComponent"
import LoadCursore from './LoadCursore'


class Wrapper extends Component {

    getChildContext() {
        return {
            formatMessage: this.props.formatMessage,
            showBlocker: this.props.showBlocker,
            hideBlocker: this.props.hideBlocker
        }
    }

    render() {
        let {children, renderButtonNav, renderFooterTop, CustomItems} = this.props

        return (
            <React.Fragment>
                <LoadCursore />
                <div className="wrapper wrapper--flex wrapper--default wrapper--fixed-header">
                    <Header renderButtonNav = {renderButtonNav} CustomItems={CustomItems} />
                    <main style={{display: 'flex'}}>
                        {children}
                    </main>
                    <Footer renderFooterTop = {renderFooterTop} />
                </div>
            </React.Fragment>
        )
    }

    static childContextTypes = {
        formatMessage: PropTypes.any,
        showBlocker: PropTypes.any,
        hideBlocker: PropTypes.any
    }
}

export default wrappedIntlComponent(blockerWrapper(Wrapper))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Wrapper.js